// extracted by mini-css-extract-plugin
module.exports = {"photoList":"instagram-index-module--photoList--361Al","photoListItem":"instagram-index-module--photoListItem--2lQPb"};